export const kebabCase = (str: string) => {
  return str.toLowerCase().replace(/\s/g, '-');
};

export const camelCase = (str: string) => {
  const split = str.split(/[-\s]+/g);
  const pos = 0;
  return split.reduce((acc: string, word: string, index: number) => {
    if (acc === '') {
      return word;
    }

    const newWord = word.charAt(0).toUpperCase() + word.substr(1, word.length);

    return `${acc}${newWord}`;
  }, '')
}


export const sentenceCase = (str: string) => {
  const strLower = str.toLowerCase();
  return `${strLower.charAt(0).toUpperCase()}${strLower.slice(1, strLower.length)}`;
}